<template>
  <div>
    <PrivacyPolicy/>
     <mobFooter />
  </div>
 
</template>

<script setup>
  import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
// import Header from "@/components/Header.vue";
 import mobFooter from "@/components/FooterAreaMobile.vue";
// export default {
//   name: "Privacy Policy",
//   components: {
//     // Header,
//     // mobFooter,
//   },
// };
</script>

<style scoped>
.aboutus {
  padding: 70px 0 0 0;
}
.textStyle {
  text-align: left;
}
.aboutus img {
  max-width: 100%;
}
.aboutus h2 {
  font-size: 55px;
  max-width: 100%;
  margin-bottom: 20px;
}
</style>
